export default __webpack_public_path__ + "static/media/logo.925dccb0.png";